import React from "react";

const RuleDescription = () => {
  return (
    <div
      style={{
        padding: "20px",
        maxWidth: "800px",
        margin: "20px auto",
        backgroundColor: "black",
        borderRadius: "10px",
        boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
      }}
    >
      <h2 style={{ textAlign: "center", color: "#3f51b5" }}>
        📜 Sheria na Masharti ya FES
      </h2>

      <ol style={{ lineHeight: "1.8", fontSize: "16px" }}>
        .Baada ya dk 90 za Match kuisha basi unapokea malipo wakatu huo huo
        <li>✅ Unashinda pale matokeo ya mwisho yanapokuwa tofauti na uliyoweka.</li>
        <li>✅ Hakuna kupoteza mtaji wako — odds hutumika kama faida ya asilimia.</li>
        <li>✅ Tumia invite code yako pekee, hairuhusiwi kutumia ya mtu mwingine.</li>
        <li>✅ Malipo yote hufanywa kupitia njia rasmi za kampuni pekee.</li>
        <li>✅ Usichelewe kuweka score kabla ya muda wa mechi kuanza.</li>
        <li>✅ Ni lazima kufuata masharti ya group rasmi kwa updates.</li>
        <li>✅ Kampuni ya FES inarudisha asilimia 100% ya mtaji wako endapo matokeo yako yamelingana au kwa lugha nyingine mkeka kuchanika.</li>
        <li>✅Unakaribishwa kwenye events mbalimbali kama kutoa misaada mbalimbali kama charity itakayo fanyika kila baada ya miezi miwili.</li>

      </ol>

      <p style={{ marginTop: "15px", fontWeight: "bold", color: "#f44336" }}>
        ⚠️ Ukienda kinyume na sheria hizi, akaunti yako inaweza kusitishwa.
      </p>

      <p style={{ marginTop: "15px", fontStyle: "italic", color: "#4caf50" }}>
        🌟 “Sheria ni mwanga wa safari — zifuate na ushindi wako utakuwa na uhakika.”
      </p>
    </div>
  );
};

export default RuleDescription;